import { ILanguage } from '@/store/entities/ILanguage';

const dataLanguages: ILanguage[] = [
  {
    locale: 'tr',
    code: 'TR',
    codeLong: 'TUR',
    name: 'Türkçe',
    icon: 'turkey',
    messages: require('@/locales/tr.json'),
  },
  {
    locale: 'en',
    code: 'EN',
    codeLong: 'ENG',
    name: 'English',
    icon: 'united-kingdom',
    messages: require('@/locales/en.json'),
  },
  {
    locale: 'ru',
    code: 'RU',
    codeLong: 'RUS',
    name: 'Russian',
    icon: 'russia',
    messages: require('@/locales/ru.json'),
  },
];

export const defaultLocale = 'ru';

export default dataLanguages;
